function toggleViewMore(sectionId) {
  const container = document.getElementById(`news-cards-${sectionId}`);
  const btn = document.getElementById(`view-toggle-${sectionId}`);
  const cards = container.querySelectorAll('.news-card');

  const isExpanded = btn.classList.contains('expanded');

  cards.forEach((card, index) => {
    if (index >= 3) {
      if (isExpanded) {
        card.classList.remove('visible');
        card.classList.add('hidden');
      } else {
        card.classList.remove('hidden');
        card.classList.add('visible');
      }
    }
  });

  btn.classList.toggle('expanded');
  btn.innerHTML = isExpanded
    ? 'View More <span class="view-toggle-arrow">▼</span>'
    : 'View Less <span class="view-toggle-arrow">▼</span>';
}


document.addEventListener('DOMContentLoaded', function() {
  const viewToggleButtons = document.querySelectorAll('.news-view-toggle-btn');
  viewToggleButtons.forEach(button => {
    button.addEventListener('click', function() {
      toggleViewMore(this.dataset.section);
    });
  });
});